module.exports = __webpack_public_path__ + "static/media/SWSCRC6-5.40b3abf8.mp3";